// extracted by mini-css-extract-plugin
export var infoRow = "_qv-2";
export var labelContainer = "_qv-0";
export var rightInfo = "_qv-1";